module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",
    class: _vm.switchClass
  }, [_c('div', {
    staticClass: "bootstrap-switch-container",
    on: {
      "click": function($event) {
        _vm.triggerToggle()
      }
    }
  }, [_c('span', {
    staticClass: "bootstrap-switch-handle-on ",
    class: ("bootstrap-switch-" + _vm.type)
  }, [_vm._t("on", [_vm._v("\n          " + _vm._s(_vm.onText) + "\n      ")])], 2), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-switch-handle-off bootstrap-switch-default"
  }, [_vm._t("off", [_vm._v("\n          " + _vm._s(_vm.offText) + "\n      ")])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-663d4ba9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Switch.vue
// module id = 524
// module chunks = 55